var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBizztm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "0.024 -0.044 202.076 72.644",
    viewBox: "0 0 202.1 72.5",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "ugc",
    role: "presentation",
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "svgcid-8nf9xaumd4qv"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.4 21.4c0-2.6 0-7.9-.1-9.3-.1-2.7-2.2-5-4.9-5.3v23.8c.9-2.8 2.7-7.6 5-9.2z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.9 14.6c-.6.6-1.4.9-2.2.9-1.7.1-3.2-1.3-3.3-3-.1-1.7 1.2-3.2 2.9-3.3h.4c1.7 0 3.1 1.4 3.2 3.1-.1 1-.4 1.8-1 2.3z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00587b",
    d: "M104.1 19v22.8h-4.9V19h4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3 37.1h11.1v4.6h-17.8v-3.3l10.7-14.8h-10.2V19h16.8v3.3l-10.6 14.8z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6 37.1h11.1v4.6h-17.8v-3.3l10.6-14.8h-10.2V19h16.8v3.3l-10.5 14.8z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.9 23.7h-5.6v10.9c-.1.7.2 1.4.6 2 .5.4 1.2.7 1.9.7h3.1v4.4c-3.8.4-6.5.1-8.1-1s-2.5-3.1-2.5-6.1V23.7h-4.2V19h4.2v-5l4.9-1.4V19h5.6v4.7z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.2 18.4c2.3-.1 4.6.8 6.2 2.5 1.6 1.8 2.5 4.3 2.4 6.7v14.1h-4.9V27.9c.1-1.3-.3-2.6-1.2-3.7-.8-.9-2-1.4-3.2-1.3-1.4-.1-2.7.5-3.6 1.5-1 1.3-1.5 2.9-1.4 4.5v12.8h-4.9V28c.1-1.3-.3-2.6-1.1-3.7-.8-.9-2-1.4-3.2-1.3-1.4-.1-2.7.5-3.6 1.5-1 1.3-1.5 2.9-1.4 4.5v12.8h-4.9V19h4.9v2.7c1.4-2.2 3.9-3.5 6.5-3.3 2.7-.1 5.2 1.3 6.5 3.6 1.4-2.4 4.1-3.8 6.9-3.6z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6 30.6c0 6.4-5.2 11.6-11.6 11.6-6.4 0-11.6-5.2-11.6-11.6C72.4 24.2 77.6 19 84 19c6.4 0 11.6 5.2 11.6 11.6zm-11.5-6.7c-3.7 0-6.7 3-6.7 6.6s3 6.7 6.6 6.7c3.7 0 6.7-2.9 6.7-6.6 0-3.7-2.9-6.7-6.6-6.7z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9 55.4h-1.7v9.5h-1.9V59H79c.3.5.5 1.1.5 1.7 0 .6-.1 1.1-.4 1.5-.3.4-.6.8-1.1 1-.5.2-1 .3-1.5.3-.6 0-1.1-.1-1.6-.4-.5-.2-.9-.6-1.2-1.1-.3-.5-.4-1-.4-1.6 0-.7.1-1.2.4-1.7s.7-.8 1.2-1 1.1-.4 1.7-.4h4.6v-2H72v-1.6h12.7v1.7zm-7.2 6.1c.3-.3.4-.6.4-1.1 0-.4-.1-.8-.4-1-.3-.3-.7-.4-1.1-.4-.4 0-.8.1-1.1.4s-.4.6-.4 1.1.1.8.4 1 .7.4 1.1.4c.4 0 .8-.2 1.1-.4z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1 55.4h-1.7v9.5h-1.9v-2.7c-.3.4-.7.7-1.2.9s-1.1.3-1.8.3c-1.3 0-2.3-.4-3-1.1s-1.1-1.8-1.1-3.1c0-.2 0-.5.1-.8h.2c.8 0 1.4-.2 1.8-.5s.6-.9.6-1.7v-.8h-3.8v-1.6h11.8v1.6zm-3.5 0h-2.5v1.2c0 .9-.2 1.5-.7 2s-1.1.8-2 .8c0 .7.2 1.3.7 1.8.4.4 1.1.7 1.8.7.8 0 1.4-.2 1.9-.7.5-.5.7-1.1.7-1.8v-4z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6 53.8c-.4-.7-.8-1.2-1.1-1.5-.3-.3-.6-.5-.8-.6-.3-.1-.7-.1-1.2-.1h-.7V50h.7c.8 0 1.4.1 1.9.3.5.2.9.5 1.4 1 .5.5 1 1.4 1.7 2.6h-1.9z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1 53.7v1.6h-1.7v9.5h-1.9v-5.3h-2.1v.9c0 1-.3 1.8-.8 2.4-.5.6-1.3.9-2.2.9-.6 0-1.1-.1-1.6-.4s-.8-.6-1.1-1c-.3-.4-.4-.9-.4-1.5 0-.9.3-1.6.9-2.1.6-.5 1.4-.7 2.3-.7h1.1v-1.2c0-.4-.1-.8-.2-1.1-.2-.3-.4-.4-.8-.4-.3 0-.6.1-.7.3-.2.2-.3.5-.3.9 0 .2 0 .3.1.5h-1.9c0-.2-.1-.4-.1-.6 0-.8.3-1.5.8-2s1.2-.8 2.1-.8c1 0 1.8.3 2.2.9s.7 1.5.7 2.5v.9h2.1v-4.2h3.5zm-7.5 5.8h-1.1c-.4 0-.8.1-1.1.3-.3.2-.4.5-.4.9s.1.7.4.9.5.3.9.3.7-.1.9-.4c.2-.3.3-.7.3-1.1v-.9z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.2 64.8v-9.5h-1.7v-1.6h5.3v1.6h-1.7v9.5h-1.9z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.4 60.1v1.7c0 .4.1.8.3 1.1s.5.4.9.4.7-.1.9-.4c.2-.3.3-.6.3-1v-.4h1.9v.3c0 .9-.3 1.7-.8 2.3-.5.6-1.3.8-2.2.8-1 0-1.8-.3-2.3-.9-.5-.6-.8-1.4-.8-2.3v-3.2h1.5c.8 0 1.4-.2 1.7-.5.4-.4.5-.9.5-1.6v-1h-5.2v-1.6h8.6v1.6h-1.5v1c0 2.5-1.2 3.7-3.5 3.7h-.3z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.2 55.4h-1.6v9.5h-1.9v-5.7h-2c-.7 0-1.3.2-1.8.5-.4.4-.6.9-.6 1.5 0 .7.2 1.2.6 1.5.4.4.9.6 1.7.6h.3v1.5h-.6c-1.2 0-2.1-.3-2.8-.9-.7-.6-1.1-1.5-1.1-2.7 0-1.2.4-2.2 1.2-2.8.8-.6 1.8-.9 3.1-.9h2.1v-2.1h-7.5v-1.6h11.1v1.6z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8 55.4V58c.2-.4.5-.7.9-.9.4-.2.9-.3 1.4-.3.6 0 1.2.1 1.6.4.5.3.8.7 1.1 1.2s.4 1.1.4 1.8-.1 1.3-.4 1.8c-.3.5-.6.9-1.1 1.2-.5.3-1 .4-1.6.4-.3 0-.7 0-1-.1V62c.1 0 .3.1.5.1.5 0 .9-.2 1.2-.5.3-.3.5-.8.5-1.3s-.2-1-.5-1.3c-.3-.3-.7-.5-1.2-.5-.6 0-1 .2-1.3.6s-.4.8-.4 1.4V65H145v-2.4c-.2.4-.6.7-1 .9s-.9.3-1.5.3-1.2-.1-1.6-.4c-.5-.3-.8-.7-1.1-1.2-.3-.5-.4-1.1-.4-1.8s.1-1.3.4-1.8c.3-.5.6-.9 1.1-1.2.5-.3 1-.4 1.7-.4.6 0 1 .1 1.4.3.4.2.7.5 1 .9v-2.6h-6.8V54h15.2v1.6h-6.6zm-2.7 6.4c.3-.2.5-.4.6-.7s.2-.6.2-.9c0-.5-.2-.9-.5-1.3s-.8-.5-1.3-.5-1 .2-1.3.5c-.3.3-.5.8-.5 1.3 0 .6.2 1 .5 1.3s.8.5 1.3.5c.4 0 .8 0 1-.2z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 53.7v1.6h-1.7v9.5h-1.9v-9.5h-1.7v-1.6h1.7v-.6c0-.5-.1-1-.3-1.4-.2-.4-.6-.6-1.1-.6-.5 0-.9.2-1.1.6s-.3.8-.3 1.4v1h-1.9v-.9c0-1.1.3-2 .8-2.7s1.4-1 2.5-1c2.2 0 3.3 1.2 3.3 3.7v.5h1.7z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.8 58.9c-.4.3-.6.8-.6 1.4 0 .5.2 1 .5 1.3.3.3.8.5 1.3.5.4 0 .8-.1 1.2-.4.3-.3.5-.7.5-1.2h1.8v4.7h-1.9v-2.5c-.2.3-.5.5-.9.7-.4.2-.8.2-1.2.2-.6 0-1.1-.1-1.6-.4s-.9-.6-1.2-1.2-.4-1.1-.4-1.9c0-.7.2-1.4.5-1.9s.8-.9 1.4-1.2 1.3-.4 2.1-.4h.7v-1.4h-6v-1.6h9.8v1.6h-1.9v3h-2.5c-.7.2-1.2.4-1.6.7z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7 68.9c-.6.5-1.3.7-2.3.7-1.1 0-2-.3-2.7-.8-.7-.5-1.1-1.4-1-2.5h1.7c0 .6.1 1.1.5 1.4.4.3.8.5 1.4.5.5 0 .9-.1 1.2-.3.3-.2.4-.5.4-.9 0-.3-.1-.6-.3-.8-.2-.2-.5-.3-.9-.3h-.4v-1.5h.4c.9 0 1.7.2 2.2.7s.7 1.1.7 2c-.1.7-.4 1.3-.9 1.8z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8 55.4V58c.2-.4.5-.7.9-.9.4-.2.9-.3 1.4-.3.6 0 1.2.1 1.6.4.5.3.8.7 1.1 1.2s.4 1.1.4 1.8-.1 1.3-.4 1.8c-.3.5-.6.9-1.1 1.2-.5.3-1 .4-1.6.4-.3 0-.7 0-1-.1V62c.1 0 .3.1.5.1.5 0 .9-.2 1.2-.5.3-.3.5-.8.5-1.3s-.2-1-.5-1.3c-.3-.3-.7-.5-1.2-.5-.6 0-1 .2-1.3.6s-.4.8-.4 1.4V65H177v-2.4c-.2.4-.6.7-1 .9s-.9.3-1.5.3-1.2-.1-1.6-.4c-.5-.3-.8-.7-1.1-1.2-.3-.5-.4-1.1-.4-1.8s.1-1.3.4-1.8c.3-.5.6-.9 1.1-1.2.5-.3 1-.4 1.7-.4.6 0 1 .1 1.4.3.4.2.7.5 1 .9v-2.6h-6.8V54h15.2v1.6h-6.6zm-2.7 6.4c.3-.2.5-.4.6-.7s.2-.6.2-.9c0-.5-.2-.9-.5-1.3s-.8-.5-1.3-.5-1 .2-1.3.5c-.3.3-.5.8-.5 1.3 0 .6.2 1 .5 1.3s.8.5 1.3.5c.4 0 .7 0 1-.2z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.4 64.8v-9.5h-1.7v-1.6h5.3v1.6h-1.7v9.5h-1.9z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.1 55.4h-1.7v9.5h-1.9V59h-2.3c.3.5.5 1.1.5 1.7 0 .6-.1 1.1-.4 1.5-.3.4-.6.8-1.1 1-.5.2-1 .3-1.5.3-.6 0-1.1-.1-1.6-.4-.5-.2-.9-.6-1.2-1.1-.3-.5-.4-1-.4-1.6 0-.7.1-1.2.4-1.7.3-.5.7-.8 1.2-1s1.1-.4 1.7-.4h4.6v-2h-9.2v-1.6h12.7v1.7zm-7.3 6.1c.3-.3.4-.6.4-1.1 0-.4-.1-.8-.4-1-.3-.3-.6-.4-1.1-.4-.4 0-.8.1-1.1.4s-.4.6-.4 1.1.1.8.4 1 .7.4 1.1.4c.5 0 .8-.2 1.1-.4z",
    fill: "#00587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 21.4-2.2-.1.8-13.1c0-1.2.3-2.4.8-3.5.4-.8.9-1.5 1.5-2.1C28.6 1.1 30.6.2 32.7 0c.9-.1 6.3 0 6.9 0 .9 0 1.7.2 2.5.5l.2.1c2.7.9 4.7 3 5.4 5.7v.1c.1.6.2 1.6.2 1.6l.8 13.3-2.2.1-.8-13.2c0-.4-.1-.9-.2-1.3-.5-2-2-3.6-4-4.2l-.2-.1c-.6-.2-1.2-.3-1.8-.3-2.3 0-6.1-.1-6.7-.1-1.6.1-3 .8-4.1 1.9l-.1.1h-.1c-.4.4-.7.9-1 1.5-.3.8-.5 1.7-.5 2.6l-.8 13.1z",
    fill: "#13142a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22.5c-.7-.1-1.1-.6-1.1-1.2l.8-13.1c0-1.2.3-2.4.8-3.5.4-.8.8-1.5 1.4-2.1C19.9 1.1 21.9.2 24 0c.9-.1 6.3 0 6.9 0 .9 0 1.7.2 2.5.5l.2.1c2.6.9 4.6 3 5.4 5.7v.1c.1.7.2 1.6.2 1.6l.8 13.3c0 .6-.4 1.1-1 1.1s-1.1-.4-1.2-1l-.7-13.2c0-.4-.1-.9-.2-1.3-.5-2-2-3.6-4-4.2h-.2c-.6-.2-1.2-.3-1.8-.3-2.3 0-6.1-.1-6.7-.1-1.6.1-3 .8-4.1 1.9l-.1.1c-.4.4-.7.9-1 1.5-.4.8-.6 1.6-.6 2.5l-.7 13.1c-.1.7-.6 1.1-1.2 1.1z",
    fill: "#13142a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 18.2 7.7 63c-.6 4.5 2.5 8.6 6.9 9.2.4.1.8.1 1.2.1h37.1c5 0 10.1-2.7 9.3-7.6l-8.6-46.5c-.2-1.4-1.4-2.4-2.8-2.4H17c-1.4-.1-2.6 1-2.8 2.4z",
    fill: "#e1bc67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8 19.7s4.1 37.5 4 41.3-.6 9.9-.6 9.9 2.1-7.3 3.1-7.1c1 .2 5.3 1.7 5.3 1.7s-5.4-4-6.3-7.3c-.4-1.6-5.5-38.5-5.5-38.5z",
    opacity: 0.3,
    fill: "#af8f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7 18.1.1 63.2c-.6 4.5 2.4 8.6 6.9 9.3.4.1.8.1 1.2.1l45.5-.2s-2.8-.8-4-6.6c-2-10-3.7-47.7-3.7-47.7-.2-1.4-1.4-2.4-2.9-2.4H9.5c-1.4 0-2.6 1-2.8 2.4z",
    fill: "#f9d69f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 262.39)",
    y2: 235.044,
    x2: 18.161,
    y1: 207.444,
    x1: 18.161,
    gradientUnits: "userSpaceOnUse",
    id: "svgcid--fq1zn42i6tqb"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03597b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4dc5d7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.1 42.6c.3-.3.7-.5 1.1-.8.1 0 .1-.1.1-.1 0-2.6 0-6.9-.1-8.5-.2-3.3-2.9-5.9-6.2-5.9v22.2m.1 0c.9-2.8 2.6-5.2 5-6.9l-5 6.9z",
    fill: "url(#svgcid--fq1zn42i6tqb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 262.39)",
    y2: 217.713,
    x2: 37.098,
    y1: 207.743,
    x1: 19.817,
    gradientUnits: "userSpaceOnUse",
    id: "svgcid-eaohbefxhvok"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03597b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4dc5d7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.7 40.8c-4.8 0-8.7 4.3-8.7 9.6 0 1.1.2 2.1.5 3.1 1.2 3.7 4.3 6.5 8 6.4-3.5-.1-6.2-3-6.2-6.4v-.2c.1-4.8 4.3-8.6 9.5-8.6s9.5 3.9 9.5 8.8c-.1-7-5.7-12.7-12.6-12.7z",
    fill: "url(#svgcid-eaohbefxhvok)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 262.39)",
    y2: 216.73,
    x2: 26.378,
    y1: 199.34,
    x1: 36.418,
    gradientUnits: "userSpaceOnUse",
    id: "svgcid-knizuv-xqkf21"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03597b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.2 53.5v-.2.2c0-4.8-4.2-8.8-9.5-8.8-1.1 0-2.1.2-3.1.5-3.6 1.1-6.2 4.3-6.4 8.1.1-3.5 2.9-6.3 6.4-6.3h.2c4.7.1 8.5 4.4 8.5 9.6s-3.9 9.6-8.7 9.6c7 0 12.7-5.7 12.6-12.7z",
    fill: "url(#svgcid-knizuv-xqkf21)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 262.39)",
    y2: 200.087,
    x2: 18.145,
    y1: 210.066,
    x1: 35.435,
    gradientUnits: "userSpaceOnUse",
    id: "svgcid--3ee9h14lmuko"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03597b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4dc5d7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.7 66.2c4.8 0 8.7-4.3 8.7-9.6 0-1.1-.2-2.1-.5-3.1-1-3.6-4.2-6.2-8-6.4 3.5.1 6.2 3 6.2 6.4v.2c-.1 4.8-4.3 8.6-9.5 8.6s-9.5-3.9-9.5-8.8c-.1 6.9 5.6 12.6 12.6 12.7-.1 0 0 0 0 0z",
    fill: "url(#svgcid--3ee9h14lmuko)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 262.39)",
    y2: 201.081,
    x2: 28.894,
    y1: 218.492,
    x1: 18.833,
    gradientUnits: "userSpaceOnUse",
    id: "svgcid--nmn5hlecimxs"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03597b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15 53.5v.2-.2c0 4.8 4.2 8.8 9.5 8.8 1.1 0 2.1-.2 3.1-.5 3.6-1.1 6.2-4.3 6.3-8.1-.1 3.5-2.9 6.3-6.3 6.3h-.2c-4.7-.1-8.5-4.3-8.5-9.6s3.9-9.6 8.7-9.6c-7 0-12.6 5.7-12.6 12.7z",
    fill: "url(#svgcid--nmn5hlecimxs)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13142a",
    d: "M40.2 21.9a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13142a",
    d: "M17.9 21.9a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizztm);
export default __webpack_public_path__ + "static/media/bizztm.fe5ad54d9236c3486a334973346aa22a.svg";
export { ForwardRef as ReactComponent };